export enum HallMaintenanceTaskCategory {
    OutdoorInspection = 'outdoor_inspection',
    IndoorInspection = 'indoor_inspection',
    DoorsAndWindows = 'doors_and_windows',
    FireProtectionSystem = 'fire_protection_system',
    WaterSupply = 'water_supply',
    Heating = 'heating',
    Ventilation = 'ventilation',
    PowerSupply = 'power_supply',
    Lighting = 'lighting',
    Tools = 'tools',
    Equipment = 'equipment'
}

export enum HallMaintenanceFrequencyUnit {
    Year = 'year',
    Month = 'month'
}

export interface HallMaintenanceTask {
    id: number;
    title: string;
    cardNumber?: string;
    subTitle?: string;
    warningText?: string;
    category: HallMaintenanceTaskCategory;
    description?: string;
    frequencyUnit: HallMaintenanceFrequencyUnit;
    frequencyInterval: number;
    frequencyLabel?: string;
    plannedMonths?: number[];
    createdAt: Date;
    updatedAt: Date;
}
